import { UpperCasePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { MessageBusService, MicroFrontendsLifecycle } from '@xdig/ng-microkernel/micro-frontend';

@Injectable()
export class LoadingMicroFrontends implements MicroFrontendsLifecycle {
  constructor(private upperCase: UpperCasePipe, private messageBus: MessageBusService) {}

  start(selector: string) {
    this.messageBus.emit('shell.animation', 'loading.begins', 'MICROFRONT_FRONTEND');
  }

  end(selector: string) {
    this.messageBus.emit('shell.animation', 'loading.ends', 'MICROFRONT_FRONTEND');
  }

  error(selector: string) {
    this.messageBus.emit('shell.animation', 'loading.ends', 'MICROFRONT_FRONTEND');
  }
}
